import React, { useEffect, useState } from "react";

import { useQuery } from "@apollo/client";
import { Select } from "antd";

import { QUERY_SCHOOLS } from "../../../../operations/queries/schools";

const SchoolsSelector = ({
  reportDefRef,
  disabled,
  mode,
  reportDefChanged,
  setReportDefChanged,
}) => {
  if (!reportDefRef?.current) {return <></>} //Wait until we have a valid reportDefRef
  // if (!reportDefRef?.current?.reportParameters?.selectedSchoolIds) {return <></>} //Wait until we have a valid reportDefRef
  
  // const defSelectedSchoolIds = reportDefRef?.current?.reportParameters?.selectedSchoolIds
  const defSelectedSchoolIds = reportDefRef?.current?.reportParameters?.selectedSchoolIds ? reportDefRef.current.reportParameters.selectedSchoolIds : []
  const [selectedSchoolIds, setSelectedSchoolIds] = useState([])

  //Get user's allowed schools
  const { data, loading, error } = useQuery(QUERY_SCHOOLS, {
    fetchPolicy: 'cache-first',
  });

  if (error) {
    return (
      <Alert
        message="Failed loading schools"
        description={error.message}
        type="error"
        showIcon
      />
    );
  }

  //Load select options from schools
  const options = (data?.schools.map((school) => ({
    label: school.name,
    value: school.id,
  })) ?? []).sort((a, b) => a.label.localeCompare(b.label));

  //Remove any selectedSchoolIds stored in reportDefRef that are not in the user's allowed schools(e.g. report def saved by someone with permission to more schools that user)
  useEffect(() => {
    if (loading || !data) return;
  
    const validOptionIds = new Set(options.map((option) => option.value));
    const validValues = defSelectedSchoolIds.filter(id => validOptionIds.has(id));
  
    // Sort both arrays before comparing (order-agnostic)
    const sortedValidValues = [...validValues].sort();
    const sortedSelected = [...selectedSchoolIds].sort();
  
    const arraysMatch = sortedValidValues.length === sortedSelected.length &&
      sortedValidValues.every((val, i) => val === sortedSelected[i]);
  
    if (!arraysMatch) {
      setSelectedSchoolIds(validValues);
      const updatedDefRef = {
        ...reportDefRef.current,
        reportParameters: { selectedSchoolIds: validValues },
      };
      reportDefRef.current = updatedDefRef;
    }
  }, [loading, data, defSelectedSchoolIds]);

  const handleSchoolIdsChange = (value) => {
    setSelectedSchoolIds(value);
    let newReportParameters = {selectedSchoolIds: value}
    let updatedDefRef = {...reportDefRef.current}
    updatedDefRef.reportParameters = newReportParameters
    reportDefRef.current = updatedDefRef
    setReportDefChanged(!reportDefChanged)
  };

  return (
    <Select
      disabled={disabled}
      mode={mode}
      allowClear
      style={{ width: '100%' }}
      placeholder={loading ? 'Loading...' : 'Select school(s) for the report'}
      value={selectedSchoolIds}
      onChange={handleSchoolIdsChange}
      options={options}
    />
  )
}

export default SchoolsSelector;
